import React, { useContext } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { AuthContext } from '../../Context/auth';

const protectedPageHOC = <P,>(Comp: React.FunctionComponent<P>) => function WrappedComp({ ...props }: P) {
  const { auth } = useContext(AuthContext);

  if (!auth) {
    return (
      <Navigate to='/login' replace />
    );
  }

  return (
    <Comp {...props} />
  );
};

export default protectedPageHOC;
